module.exports = __webpack_public_path__ + "static/img/blog3.e8e211d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/blog3.jpg
// module id = 4fKA
// module chunks = 0